import { LogLevel } from "@azure/msal-browser";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;

export const msalConfig = {
  auth: {
    clientId: "b5ca6624-8413-4546-bb40-a47bb620d5a2",
    authority: "https://login.microsoftonline.com/f211770e-b3bf-4850-af0a-aee4b2ea894e",
    consentScopes: [
      "user.read",
      "api://2b8b177c-2966-4a38-8519-9e4c60fdc6c7/Access"
    ],
    protectedResourceMap: [ 
      "https://bomeditorqa.varsity.com/api",
      [
        "api://2b8b177c-2966-4a38-8519-9e4c60fdc6c7/Access"
      ]
    ],
    redirectUri: "https://bomeditorqa.varsity.com",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isIE || isEdge, 
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {	
            return;	
        }

        switch (level) {	
          case LogLevel.Error:	
            console.error(message);	
            return;	
          case LogLevel.Info:	
            console.info(message);	
            return;	
          case LogLevel.Verbose:	
            console.debug(message);	
            return;	
          case LogLevel.Warning:	
            console.warn(message);	
            return;	
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ["User.Read"]
};

export const tokenRequest = {
  scopes: ["api://2b8b177c-2966-4a38-8519-9e4c60fdc6c7/Access"]
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMePhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photos/48x48/$value"
};

export const apiUrl = "https://bomeditorqa.varsity.com/api";

export const showSetupChart = true;

export const roleBasedMenuAccess: { [role: string]: RolePermissions } = {
  "Basic": {
    menu: ["Raw Material Master", "Material Group"],
    tabs: {}
  },
  "Engineering": {
    menu: ["Material Usage", "Raw Material Group"],
    tabs: {}
  },
  "Costing": {
    menu: ["Costing", "Style"],
    tabs: {
      Style: ["Cost Elements", "Minutes"]
    }
  },
  "Master_Data": {
    menu: ["Braid", "Style", "Table Maintenance", "Product Hierarchy", "Setup Charts"],
    tabs: {
      Style: [
        "Bill of Material",
        "Style Setup",
        "Drawing",
        "Style Rules",
        "Stripe Details",
        "Lettering",
        "Quantity Pricing",
        "Detailing Exceptions",
        "Item Specs"
      ],
      "Table Maintenance": [
        "Category",
        "Group",
        "Setup Options",
        "Charts",
        "Packages",
        "Stripes",
        "Letter Pricing",
        "Min Qty Groups",
        "Drawings",
        "Fabric",
        "Custom Lettering Templates"
      ]
    }
  },
  "Raw_Material": {
    menu: ["Raw Material Group", "Material Usage", "Style"],
    tabs: {
      Style: ["Bill of Material", "Stripe Details", "Lettering"]
    }
  },
  "Admin": {
    menu: ["All Menus"],
    tabs: {}
  }
};